
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"stroke-width":"1.6","x":"2.5","y":"3.75","width":"25","height":"22.5","rx":"1.65","ry":"1.65"}}),_c('path',{attrs:{"stroke-width":"1.2","d":"M6.88 14.08v6.84a.84.84 0 001.31.7l5.13-3.41a.86.86 0 000-1.42l-5.13-3.41a.84.84 0 00-1.31.7zM19.38 13.75h5M19.38 17.5h5M19.38 21.25h5"}}),_c('path',{attrs:{"stroke-width":"1.6","d":"M2.5 8.12h25"}})])])
          )
        }
      }
    